// extracted by mini-css-extract-plugin
var _1 = "StudentName__displayName--e_mP7";
var _2 = "StudentName__displayNameReg--zUoq5 StudentName__displayName--e_mP7";
var _3 = "StudentName__name--alHQJ";
var _4 = "StudentName__nameReg--E0YPC StudentName__name--alHQJ";
var _5 = "StudentName__noUsernameSpacing--nNUpf";
var _6 = "StudentName__panelAvatar--_u_2w";
var _7 = "StudentName__username--oh_8A";
export { _1 as "displayName", _2 as "displayNameReg", _3 as "name", _4 as "nameReg", _5 as "noUsernameSpacing", _6 as "panelAvatar", _7 as "username" }
